var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _line, _line2, _line3, _path8, _path9, _path0, _path1, _rect, _path10, _path11, _path12, _path13, _path14, _g, _path15, _rect2, _rect3, _rect4, _circle, _path16, _path17, _path18, _path19, _path20, _path21, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _rect1, _path55, _path56, _path57, _path58, _path59, _rect10, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _polygon, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _line4, _path86, _line5, _path87, _path88;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomework(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M190.91,359.69v24c0,7,5.63,5.8,10.36,6.13l41.79-.61c11.67,0,16.34-.24,5.54-5.85-10.57-5.48-39.21-22-51.81-29.35C192.2,351.37,190.78,351.74,190.91,359.69Z",
    clipRule: "evenodd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M178,214.14V112.23a8.92,8.92,0,0,1,8.89-8.89H429.37a8.91,8.91,0,0,1,8.88,8.89V250.49a8.91,8.91,0,0,1-8.88,8.89H186.89a8.92,8.92,0,0,1-8.89-8.89V235.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M417.41,223.6c-50.36-46.37-97-5.6-97,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M208.17,136.59l-4-5.81-4.06,5.81a10.09,10.09,0,0,1-1.49,1.74,2.27,2.27,0,0,1-1.55.52,2.55,2.55,0,0,1-1.76-.65,2,2,0,0,1-.74-1.49,5.08,5.08,0,0,1,1.12-2.46l4.94-7.08-4.37-5.91a4.37,4.37,0,0,1-1.15-2.54,1.9,1.9,0,0,1,.69-1.46,2.53,2.53,0,0,1,1.77-.62,2.34,2.34,0,0,1,1.59.54,10.22,10.22,0,0,1,1.47,1.7l3.54,4.85,3.44-4.85a9.76,9.76,0,0,1,1.49-1.72,2.36,2.36,0,0,1,1.57-.52,2.68,2.68,0,0,1,1.79.61,1.89,1.89,0,0,1,.71,1.47,2.46,2.46,0,0,1-.29,1.19,7.92,7.92,0,0,1-.89,1.35l-4.38,5.91,4.94,7.08a5.25,5.25,0,0,1,1.16,2.5,1.88,1.88,0,0,1-.72,1.48,2.61,2.61,0,0,1-1.78.62,2.41,2.41,0,0,1-1.59-.54,9.28,9.28,0,0,1-1.49-1.72Zm16.69-6.47h-6.32a3.15,3.15,0,0,1-2.19-.67,2.23,2.23,0,0,1-.75-1.74,2.26,2.26,0,0,1,.73-1.75,3.14,3.14,0,0,1,2.21-.67h6.32a3.19,3.19,0,0,1,2.22.67,2.29,2.29,0,0,1,.73,1.75,2.25,2.25,0,0,1-.73,1.74,3.14,3.14,0,0,1-2.22.67Zm11.5,9.42.51-1.22-6.72-16.93a6.25,6.25,0,0,1-.62-2.13,2.5,2.5,0,0,1,.36-1.3,2.68,2.68,0,0,1,1-1,2.58,2.58,0,0,1,1.3-.36,2.15,2.15,0,0,1,1.79.75,6.83,6.83,0,0,1,1.05,2.15L239.65,133l4.38-12.5a20.59,20.59,0,0,1,.94-2.39,2.77,2.77,0,0,1,.89-1.16,2.45,2.45,0,0,1,1.33-.3,2.38,2.38,0,0,1,1.19.33,2.42,2.42,0,0,1,.88.89,2.47,2.47,0,0,1,.3,1.19c-.05.25-.13.61-.26,1.07s-.26.95-.43,1.43l-7.13,18.65a22,22,0,0,1-1.79,3.86,5.9,5.9,0,0,1-2.34,2.15,8.51,8.51,0,0,1-3.9.75,9.44,9.44,0,0,1-3.6-.52,1.89,1.89,0,0,1-1.2-1.89,1.83,1.83,0,0,1,.57-1.45,2.44,2.44,0,0,1,1.69-.51,3.56,3.56,0,0,1,.86.11,4.23,4.23,0,0,0,.9.13,3.25,3.25,0,0,0,1.47-.28,2.57,2.57,0,0,0,1-1,14.54,14.54,0,0,0,1-2Zm52.5-16.63-10,11.19h10.7a2.82,2.82,0,0,1,2,.6,2.08,2.08,0,0,1,.66,1.58,1.94,1.94,0,0,1-.65,1.5,2.88,2.88,0,0,1-2,.58H274.75a3.47,3.47,0,0,1-2.33-.68,2.37,2.37,0,0,1-.77-1.86,2.31,2.31,0,0,1,.54-1.41c.36-.48,1.11-1.34,2.24-2.61s2.3-2.54,3.27-3.63,1.89-2.09,2.73-3,1.54-1.74,2.09-2.39,1-1.22,1.34-1.68h-8.12a8.58,8.58,0,0,1-2.55-.3c-.57-.2-.86-.73-.86-1.58a1.89,1.89,0,0,1,.65-1.5,2.76,2.76,0,0,1,1.85-.56h12.55a5.52,5.52,0,0,1,2.67.52,1.88,1.88,0,0,1,.93,1.82,2.54,2.54,0,0,1-.18.91,3.24,3.24,0,0,1-.4.77c-.15.2-.35.44-.6.73Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M264.32,131.05h-9.73v-2.49h9.73v2.49Zm0-4.22h-9.73v-2.48h9.73Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M306.76,120.49h56a3.17,3.17,0,0,1,3.16,3.16h0a3.17,3.17,0,0,1-3.16,3.16h-56a3.16,3.16,0,0,1-3.15-3.16h0A3.16,3.16,0,0,1,306.76,120.49Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M377.54,120.49h42.88a3.16,3.16,0,0,1,3.15,3.16h0a3.16,3.16,0,0,1-3.15,3.16H377.54a3.17,3.17,0,0,1-3.16-3.16h0A3.17,3.17,0,0,1,377.54,120.49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M306.76,138.85H353A3.16,3.16,0,0,1,356.2,142h0a3.17,3.17,0,0,1-3.16,3.16H306.76a3.16,3.16,0,0,1-3.15-3.16h0A3.16,3.16,0,0,1,306.76,138.85Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 223.48,
    x2: 417.41,
    y1: 223.6,
    y2: 223.6,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 320.45,
    x2: 320.45,
    y1: 212.62,
    y2: 234.57,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 417.41,
    x2: 417.41,
    y1: 212.62,
    y2: 234.57,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M320.44,200.7a3.76,3.76,0,1,1-3.75,3.75A3.75,3.75,0,0,1,320.44,200.7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M417.41,200.7a3.76,3.76,0,1,1-3.76,3.75A3.76,3.76,0,0,1,417.41,200.7Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M349.37,192.68l.24-.58-3.15-7.94a3,3,0,0,1-.3-1,1.23,1.23,0,0,1,.17-.62,1.33,1.33,0,0,1,.47-.44,1.13,1.13,0,0,1,.61-.17,1,1,0,0,1,.84.35,3.06,3.06,0,0,1,.49,1l2.17,6.3,2-5.86a11.6,11.6,0,0,1,.45-1.12,1.3,1.3,0,0,1,.41-.54,1.13,1.13,0,0,1,.63-.14,1.08,1.08,0,0,1,.55.15,1.13,1.13,0,0,1,.42.42,1.18,1.18,0,0,1,.14.55q0,.18-.12.51c-.06.22-.12.44-.2.67L351.89,193a9.93,9.93,0,0,1-.84,1.82,2.79,2.79,0,0,1-1.09,1,4.1,4.1,0,0,1-1.84.35,4.27,4.27,0,0,1-1.68-.25.89.89,0,0,1-.57-.89.87.87,0,0,1,.27-.68,1.2,1.2,0,0,1,.79-.23,1.4,1.4,0,0,1,.41,0,1.76,1.76,0,0,0,.42.06,1.63,1.63,0,0,0,.69-.13,1.26,1.26,0,0,0,.46-.46A7.13,7.13,0,0,0,349.37,192.68Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M320.44,238.35a3.76,3.76,0,1,1-3.75,3.76A3.76,3.76,0,0,1,320.44,238.35Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 131.7,
    height: 23.12,
    x: 178,
    y: 271.71,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 4.37
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M190.37,278.11a5.17,5.17,0,1,1-5.17,5.16A5.16,5.16,0,0,1,190.37,278.11Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M212,278.11a5.17,5.17,0,1,1-5.16,5.16A5.16,5.16,0,0,1,212,278.11Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M236.19,278.11a5.17,5.17,0,1,1-5.16,5.16A5.16,5.16,0,0,1,236.19,278.11Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M254.46,281.11h44.8a2.16,2.16,0,0,1,2.16,2.16h0a2.17,2.17,0,0,1-2.16,2.17h-44.8a2.17,2.17,0,0,1-2.17-2.17h0A2.17,2.17,0,0,1,254.46,281.11Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M181.93,305.84H331.78a5.8,5.8,0,0,1,5.8,5.8v85.29a5.81,5.81,0,0,1-5.81,5.81H181.93a5.81,5.81,0,0,1-5.81-5.81V311.64A5.81,5.81,0,0,1,181.93,305.84Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.46,
    height: 13.02,
    x: 186.63,
    y: 378.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 3.73
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M190.91,359.69v24c0,7,5.63,5.8,10.36,6.13l41.79-.61c11.67,0,16.34-.24,5.54-5.85-10.57-5.48-39.21-22-51.81-29.35C192.2,351.37,190.78,351.74,190.91,359.69Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 85.68,
    height: 6.94,
    x: 190.9,
    y: 321.63,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 3.47
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 36.07,
    height: 6.94,
    x: 286.74,
    y: 321.63,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 3.47
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 110.92,
    height: 6.94,
    x: 190.9,
    y: 336.44,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 3.47
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 402.74,
    cy: 160.4,
    r: 13.77,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M379.9,140.53c.94,1.26,22.84,19.87,22.84,19.87l-18.31,17.52"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M421.51,147.89c-1.41.47-18.77,12.51-18.77,12.51l6.72,29.41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M372.47,144.88l-2.11-3.09-2.16,3.09a5.67,5.67,0,0,1-.79.93,1.26,1.26,0,0,1-.83.28,1.39,1.39,0,0,1-.94-.35,1,1,0,0,1-.39-.79,2.64,2.64,0,0,1,.6-1.31l2.63-3.77-2.33-3.15a2.3,2.3,0,0,1-.61-1.35,1,1,0,0,1,.36-.78,1.36,1.36,0,0,1,1-.33,1.24,1.24,0,0,1,.85.29,5.56,5.56,0,0,1,.78.9l1.88,2.58,1.84-2.58a4.91,4.91,0,0,1,.79-.91,1.23,1.23,0,0,1,.83-.28,1.44,1.44,0,0,1,1,.32,1,1,0,0,1,.38.79,1.4,1.4,0,0,1-.16.63,4.13,4.13,0,0,1-.47.72l-2.33,3.15,2.62,3.77a2.69,2.69,0,0,1,.62,1.33,1,1,0,0,1-.38.79,1.41,1.41,0,0,1-.95.33,1.33,1.33,0,0,1-.85-.29A5.41,5.41,0,0,1,372.47,144.88Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M416.45,194.05l.27-.65-3.6-9.06a3.39,3.39,0,0,1-.33-1.14,1.44,1.44,0,0,1,.73-1.21,1.43,1.43,0,0,1,.69-.19,1.18,1.18,0,0,1,1,.4,3.73,3.73,0,0,1,.56,1.15l2.48,7.2,2.34-6.69a12.37,12.37,0,0,1,.5-1.28,1.55,1.55,0,0,1,.48-.62,1.38,1.38,0,0,1,.71-.16,1.3,1.3,0,0,1,1.11.66,1.23,1.23,0,0,1,.16.63c0,.13-.07.33-.14.57a7.32,7.32,0,0,1-.23.76l-3.81,10a12.11,12.11,0,0,1-1,2.07,3.14,3.14,0,0,1-1.25,1.15,4.58,4.58,0,0,1-2.09.4,5.24,5.24,0,0,1-1.93-.27,1,1,0,0,1-.64-1,.93.93,0,0,1,.31-.77,1.26,1.26,0,0,1,.9-.28,1.76,1.76,0,0,1,.46.06,1.85,1.85,0,0,0,.48.07,1.71,1.71,0,0,0,.79-.15,1.36,1.36,0,0,0,.52-.52A8.64,8.64,0,0,0,416.45,194.05Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M284.24,155h68.87a3.16,3.16,0,0,1,3.16,3.15h0a3.17,3.17,0,0,1-3.16,3.16H284.24a3.17,3.17,0,0,1-3.16-3.16h0A3.16,3.16,0,0,1,284.24,155Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M284.24,171.34h68.87a3.17,3.17,0,0,1,3.16,3.16h0a3.17,3.17,0,0,1-3.16,3.16H284.24a3.17,3.17,0,0,1-3.16-3.16h0A3.17,3.17,0,0,1,284.24,171.34Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 38.38,
    height: 5.26,
    x: 299.2,
    y: 413.58,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 2.63
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 9.63,
    height: 5.26,
    x: 286.5,
    y: 413.58,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 2.63
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 26.25,
    height: 5.26,
    x: 311.33,
    y: 427.29,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 2.63
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 51.32,
    height: 7.28,
    x: 115.24,
    y: 67.67,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 3.64
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 12.88,
    height: 7.28,
    x: 98.24,
    y: 67.67,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 3.64
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 35.11,
    height: 7.28,
    x: 131.45,
    y: 82.78,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 3.64
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    d: "M78.33,469.53l-.12.21.36,2.89,8.51.22.3-1.78,2,1.51h19.82l.06-2.65a4.33,4.33,0,0,1-.25.77l-25.38-.32Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    d: "M121.07,470.41l-.12.23.38,3.08,9.07.23.32-1.9,2.11,1.61H154l.06-2.82a4.58,4.58,0,0,1-.26.83l-27.06-.35Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M204.26,40.16a7.82,7.82,0,1,1-9,6.45A7.82,7.82,0,0,1,204.26,40.16Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M263.39,439.12a8.52,8.52,0,0,1-6.58-9.86,8.09,8.09,0,0,1,9.23-7,8.54,8.54,0,0,1,6.58,9.87A8.09,8.09,0,0,1,263.39,439.12Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M249.48,437.32a1.47,1.47,0,0,0-1.26-2.65,49.25,49.25,0,0,1-5.27,2.14,1.46,1.46,0,0,0,.3,2.83,1.42,1.42,0,0,0,.65-.07,51.62,51.62,0,0,0,5.58-2.25Zm-88.66-56a1.47,1.47,0,0,0-2.84-.61,1.61,1.61,0,0,0-.08.38c-.08,1.05-.13,2.08-.17,3.12a1.47,1.47,0,0,0,2.92.21c.07-1,.09-2.07.17-3.1Zm1.19,17.1a1.5,1.5,0,0,0-1-1.06,1.47,1.47,0,0,0-1.84,1.75,53,53,0,0,0,1.71,5.77,1.47,1.47,0,0,0,2.8-.87l0-.14a47.26,47.26,0,0,1-1.61-5.45Zm8.34,17.88a1.46,1.46,0,0,0-2.54,1.38,1.9,1.9,0,0,0,.21.4,53,53,0,0,0,3.89,4.59,1.46,1.46,0,0,0,2.37-1.64,1.48,1.48,0,0,0-.26-.39,48.94,48.94,0,0,1-3.67-4.34Zm14.71,13.31a1.46,1.46,0,1,0-1.54,2.48c1.7,1.06,3.43,2,5.21,2.93a1.46,1.46,0,1,0,1.32-2.61q-2.56-1.31-5-2.8Zm18.36,7.86a1.46,1.46,0,0,0-1.07,2.7,1.27,1.27,0,0,0,.32.13c1.92.52,3.86,1,5.82,1.32a1.47,1.47,0,0,0,1-2.72,1.57,1.57,0,0,0-.46-.16q-2.82-.52-5.59-1.27ZM223.28,440a1.46,1.46,0,0,0-.25,2.9,1.43,1.43,0,0,0,.29,0c2,0,4-.13,6-.31a1.46,1.46,0,0,0,.31-2.85,1.4,1.4,0,0,0-.58-.06C227.1,439.9,225.2,440,223.28,440Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M273.24,243l-2.11-3.1L269,243a6.14,6.14,0,0,1-.79.93,1.26,1.26,0,0,1-.83.27,1.36,1.36,0,0,1-.94-.34,1.06,1.06,0,0,1-.39-.8,2.68,2.68,0,0,1,.6-1.31l2.63-3.77-2.33-3.14a2.32,2.32,0,0,1-.61-1.35,1,1,0,0,1,.36-.78,1.31,1.31,0,0,1,.95-.33,1.24,1.24,0,0,1,.84.28,5.63,5.63,0,0,1,.79.91l1.88,2.58L273,233.6a5,5,0,0,1,.8-.92,1.27,1.27,0,0,1,.83-.27,1.38,1.38,0,0,1,1,.32,1,1,0,0,1,.38.79,1.39,1.39,0,0,1-.15.63,5.24,5.24,0,0,1-.48.72L273,238l2.63,3.77a2.81,2.81,0,0,1,.62,1.34,1,1,0,0,1-.38.78,1.43,1.43,0,0,1-.95.33A1.3,1.3,0,0,1,274,244,5.36,5.36,0,0,1,273.24,243Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M73.15,161.59a4.56,4.56,0,1,1-4.55,4.56A4.56,4.56,0,0,1,73.15,161.59Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M354.25,278.75a4.93,4.93,0,1,1-4.93,4.93A4.93,4.93,0,0,1,354.25,278.75Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M399,473.62a8.87,8.87,0,0,0-4.65-5,37.68,37.68,0,0,0,1.2,4c.28.74-2.83-1-3.26-1.7-.57-.9-1.12-1.82-1.64-2.77-4.62.52-7,5.14-7,5.14Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M382.42,439.85c.69,10,4,21.81,9.86,31.08.43.69,3.54,2.44,3.26,1.7-2.16-5.89-2.55-12.12-3-18.24-.32-5.15-.4-10.06-.32-13.67A52.4,52.4,0,0,1,382.42,439.85Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M420.67,473.62a9.32,9.32,0,0,0-3-4.06,31.17,31.17,0,0,0,1,3.07c.27.74-2.83-1-3.27-1.7-.58-.91-1.12-1.84-1.65-2.8h-.19c-5.4-.22-8.2,5.18-8.2,5.18Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M405.51,440.24c.75,9.91,4,21.54,9.83,30.69.44.69,3.54,2.44,3.27,1.7-2.17-5.89-2.56-12.12-2.95-18.24s-.43-11.67-.28-15.34c-3.64.21-7.71.13-8.22-1h0a1.74,1.74,0,0,1-.69,2.05Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M379.35,414.48l-1.22,22.41c-.3,5.46,25.39,3.62,28.33,3.25a1.81,1.81,0,0,0,.65-2.23c.21,1.93,10.2,1.15,13.28.62,6.31-1.07,4.16-3.39,4.16-3.39l-1.68-23.22"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M411.28,426.35a.37.37,0,0,1,.37.36.35.35,0,0,1-.35.37,4.57,4.57,0,0,0-2.48.55h0a2.75,2.75,0,0,0-.85,2.18c-.13,2.24-.07,6.25-.05,7.75V438a.36.36,0,0,1-.36.37.37.37,0,0,1-.37-.36v-.45c0-1.52-.08-5.55.06-7.8a3.33,3.33,0,0,1,1.14-2.72l0,0A5.14,5.14,0,0,1,411.28,426.35Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M384.15,415.61c-.19,4.41.65,6.84,1.58,8.13a3.54,3.54,0,0,0,1.12,1.05,1.54,1.54,0,0,0,.66.22.37.37,0,0,1,.53.48.57.57,0,0,1-.46.25,2.12,2.12,0,0,1-1.09-.32,4.24,4.24,0,0,1-1.35-1.25c-1-1.4-1.92-4-1.72-8.67Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M388.77,416.14l-.91,23.25a.37.37,0,0,1-.38.35.37.37,0,0,1-.35-.38l.92-23.28Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M374.09,361.34l-17.7-4.18,6,26.55s4.27,1.7,9,3.44"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M405.41,349.93a13.08,13.08,0,0,0,.2-3m-13,1.8c0,.5-.08,1-.14,1.49"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M377.66,313.12c-1.11,8.16-4.28,8.42-5.25,15.33-1.55,11,8.8,19.33,20.23,20.07"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M433.91,329.69c9.59-8.92,14.42-33.41-3.52-39.52,4.61-11.26-12-18.89-17.34-13-2.39-6.87-18.26-9.34-20.6,1.25-9.14-7.94-21.16,2.4-18.74,12.71-10.73,4.5-6.68,15.45,4.84,15-5.56,4.5,1,10.29,4.6,8.75-.56,1.75-3.14,10,.61,8.55,3.48-1.38,6.05,4.24,4.86,8.12-1.75,5.68-6.49,3.52-8.54,2.29-5.15-3.06-6,10.41,6.51,13.83a31,31,0,0,0,24.54-3.12c10.63,4,18.84-5.56,14.66-11.64a7.18,7.18,0,0,0,2.07,0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M388.23,351.74c4.52-2.17,11.13-2.92,16.81-2.29,10.81-.75,6.41.37,15.63-1.51,9.58-2,9.94,13.81,7,15.23-4.18,2-2.09.82-8.53,2.58h0a299.62,299.62,0,0,1,5.27,39.33c.29,4.84.79,3.34.69,5.29-.3,5.88-37.64,8-46.28,3.86-3.47-1.66.11-5.07-.21-7.81a63.47,63.47,0,0,1-.22-9.66"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M371.28,385.3c-.15,4.26.31,10.78,4.45,11.83,4.46,1.13,6.34-6.34,7.06-10.7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M429.29,358.27c3.55-1.76,6.8-4,8.74-6.73.65-6.15-.85-13.63-4-21.59-.85-2.13-1.83-4.29-2.92-6.47,0,0,.06-6.3-3.51-9.13-2.06-1.64-8.49-2.12-8,.72.34,1.9,1.69,1.18,3.23,3,1.4,1.68.2,4,.44,4.74a2.41,2.41,0,0,1-1.11-.55c-.72-.52-1.39,0-1,1.09.57,1.8,2.46,1.39,3.57,3,2.24,3.2,6.35,14.23,6.23,20.21a14.31,14.31,0,0,1-5.86,1.88C428.17,350.13,429.36,354.66,429.29,358.27Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M388.93,368c-.84,2.81-1.78,5.63-2.63,8.15-1.47,4.36-2.66,7.81-2.52,8.69.44,2.82-9.78,3.07-12.25.93-2-1.74-1.28-16.61,3.36-26.29,2-4.22,8.66-6.55,14-7.77"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M457.88,270.62a.73.73,0,0,1-.94,1.11s-9-7.7-12.62-2a3.57,3.57,0,0,0,.09,3.88h.15a7.33,7.33,0,0,1,2.66.31,11.74,11.74,0,0,1,5.85,4.16c.78,1,.74,1.77.14,2.22a2.92,2.92,0,0,1-2.47-.06,15.3,15.3,0,0,1-3.13-1.55,15.06,15.06,0,0,1-3.86-3.42,2.53,2.53,0,0,0-.67.36,2.93,2.93,0,0,0-1,1.59,4.49,4.49,0,0,0,.69,3.44,8.31,8.31,0,0,1,1.38.24h0a5.75,5.75,0,0,1,4.08,3.37,1.62,1.62,0,0,1,0,1.4l-.05.08c-.39.53-1.08.57-1.91.21a8.87,8.87,0,0,1-1.92-1.27,13.45,13.45,0,0,1-2.37-2.62,4.34,4.34,0,0,0-1.23.2,1.83,1.83,0,0,0-1.29,1.18c-.72,2.61,2,4.1,2,4.1a.72.72,0,0,1,.29,1,.71.71,0,0,1-1,.29S437,286.74,438,283a3.18,3.18,0,0,1,2.23-2.18,5,5,0,0,1,.89-.2,5.43,5.43,0,0,1-.49-3.88,4.38,4.38,0,0,1,1.56-2.35A4.08,4.08,0,0,1,443,274a4.84,4.84,0,0,1,.14-5.06c4.49-7.08,14.76,1.68,14.79,1.71Zm-12.4,4.4a14.49,14.49,0,0,0,2.91,2.38,14.2,14.2,0,0,0,2.82,1.41,2.82,2.82,0,0,0,1.13.26c.13-.09-.27.06-.44-.17a10.27,10.27,0,0,0-5.1-3.63,6.5,6.5,0,0,0-1.32-.25ZM444,282.35a13.63,13.63,0,0,0,1.23,1.19,7.43,7.43,0,0,0,1.54,1,4.22,4.22,0,0,0-2.77-2.23Zm2.9,2.46c0,.05,0,.08,0,0h0S446.94,284.82,446.92,284.81Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M351.72,321.63c1.24-.5,3,3.34,5.09,2.33s2.66-2,3.36-1.18c1,1.18-1.55,3.09-.54,4.64s2.83,1.5,2.16,3-3.91-.63-4.51.32,0,4-1.95,3.92-.51-4.48-2.6-4.68-3.75.81-4-.54c-.12-.79,1.24-1.31,2.15-1.79C353.79,326.1,349.56,322.5,351.72,321.63Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M275.34,358.81l.43,23.8,20.28,9.73,17.11-8.15.9-25.28-17.69,8.46-21-8.56Zm-1.13,23.83L273.78,359a1.57,1.57,0,0,1,2.14-1.6l20.41,8.3,17-8.13a1.47,1.47,0,0,1,.78-.18,1.55,1.55,0,0,1,1.5,1.61l-.89,25.16a1.59,1.59,0,0,1-.9,1.49l-17.1,8.14h0a1.57,1.57,0,0,1-1.34,0L275.13,384A1.54,1.54,0,0,1,274.21,382.64Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M294.25,351.23l-18.79,6.67,20.84,8.4L313.77,358l-19.52-6.81Zm-19.31,5.19,18.79-6.66h0a1.61,1.61,0,0,1,1,0l19.45,6.78a1.52,1.52,0,0,1,1,.83,1.56,1.56,0,0,1-.74,2.08L297,367.72h0a1.55,1.55,0,0,1-1.25,0l-20.79-8.38a1.59,1.59,0,0,1-.95-.95A1.57,1.57,0,0,1,274.94,356.42Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M293.57,350.93a.79.79,0,1,1,1.57,0Zm.14,24.76-.14-24.76h1.57l.14,24.76-.51.74-1.06-.73Zm1.57,0a.79.79,0,0,1-1.57,0Zm-20.2,6.46L294.22,375l.55,1.47-19.14,7.19-.55-1.47Zm.55,1.47a.78.78,0,1,1-.55-1.47Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M313.48,383.48a.78.78,0,0,1,.4,1,.8.8,0,0,1-1,.4l.64-1.43ZM294.57,375l18.91,8.52-.64,1.43-18.91-8.52.64-1.43Zm-.64,1.43a.78.78,0,0,1,.64-1.43Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M295.59,367.36a.78.78,0,1,1,1.56,0Zm-.08,25.49.08-25.49h1.56l-.07,25.48Zm1.57,0a.79.79,0,1,1-1.57,0Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M270.2,357.45l.14-.35-1.91-4.81a1.73,1.73,0,0,1-.17-.6.66.66,0,0,1,.1-.37.75.75,0,0,1,.28-.28.82.82,0,0,1,.37-.1.62.62,0,0,1,.51.21,2.24,2.24,0,0,1,.3.62l1.31,3.82,1.25-3.56a4.5,4.5,0,0,1,.26-.67.71.71,0,0,1,.26-.33.63.63,0,0,1,.37-.09.66.66,0,0,1,.59.35.66.66,0,0,1,.09.33l-.07.31c0,.13-.08.27-.13.4l-2,5.3a6.89,6.89,0,0,1-.51,1.1,1.64,1.64,0,0,1-.67.61,2.43,2.43,0,0,1-1.11.22,2.67,2.67,0,0,1-1-.15.54.54,0,0,1-.34-.54.5.5,0,0,1,.16-.41.69.69,0,0,1,.48-.15,1.07,1.07,0,0,1,.25,0,.85.85,0,0,0,.25,0,1,1,0,0,0,.42-.08.75.75,0,0,0,.28-.28A5.07,5.07,0,0,0,270.2,357.45Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M320,388.37l-1.13-1.65-1.15,1.65a3.69,3.69,0,0,1-.42.5.65.65,0,0,1-.44.14.76.76,0,0,1-.51-.18.56.56,0,0,1-.2-.42,1.37,1.37,0,0,1,.31-.7l1.41-2L316.66,384a1.3,1.3,0,0,1-.32-.72.55.55,0,0,1,.19-.42.72.72,0,0,1,.51-.18.69.69,0,0,1,.45.16,2.73,2.73,0,0,1,.42.48l1,1.38,1-1.38a2.52,2.52,0,0,1,.42-.49.68.68,0,0,1,.45-.15.76.76,0,0,1,.51.18.53.53,0,0,1,.2.42.76.76,0,0,1-.08.33,2.62,2.62,0,0,1-.26.39l-1.24,1.68,1.4,2a1.46,1.46,0,0,1,.33.71.53.53,0,0,1-.2.42.75.75,0,0,1-.51.17.7.7,0,0,1-.45-.15A2.52,2.52,0,0,1,320,388.37Z"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 260.67,
    height: 33.67,
    x: 177.79,
    y: 62.03,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 6.36
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M195.53,71.35A7.52,7.52,0,1,1,188,78.86,7.51,7.51,0,0,1,195.53,71.35Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M227.1,71.35a7.52,7.52,0,1,1-7.52,7.51A7.51,7.51,0,0,1,227.1,71.35Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M262.27,71.35a7.52,7.52,0,1,1-7.51,7.51A7.51,7.51,0,0,1,262.27,71.35Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M288.88,75.71h65.24a3.16,3.16,0,0,1,3.16,3.15h0A3.17,3.17,0,0,1,354.12,82H288.88a3.17,3.17,0,0,1-3.16-3.16h0A3.16,3.16,0,0,1,288.88,75.71Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M370.21,75.71h50.21a3.16,3.16,0,0,1,3.15,3.15h0A3.16,3.16,0,0,1,420.42,82H370.21a3.17,3.17,0,0,1-3.16-3.16h0A3.16,3.16,0,0,1,370.21,75.71Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 31.52,
    height: 4.47,
    x: 41.86,
    y: 175.02,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 2.24
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M432.27,267c.72.39-.4,2.69.88,3.27s2,.45,1.85,1.12c-.18.9-2,.47-2.38,1.54s.4,1.89-.55,2.15-1.21-2.07-1.89-2-1.86,1.52-2.58.6,1.89-2,1.18-3-1.82-1.43-1.27-2c.32-.36,1.09.08,1.66.31C431,269.72,431,266.36,432.27,267Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M448,338a4.12,4.12,0,1,1-4.12,4.11A4.11,4.11,0,0,1,448,338Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    d: "M89.68,460s6.13,2.77,8.16,3.41,6.74-.1,9.68,1.84a4,4,0,0,1,1.47,5.08l-25.38-.32-5.37-.87,1-8.69v.62c3.81,1.51,6.86.44,10.4-1.07Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    d: "M133.63,460.33s6.08,2.94,8.24,3.63,7.19-.12,10.32,2a4.33,4.33,0,0,1,1.57,5.42L126.7,471l-5.72-.92,1.11-9.28v.67c4.06,1.61,7.76.48,11.53-1.13Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M79.28,456.62v4.49c3.81,1.51,6.86.44,10.4-1.07l.3-3.32Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M122.09,456.48v5c4.06,1.61,7.76.48,11.54-1.13l-.48-3.66Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M113.21,349.88c7.45,34.75,11.14,83.95,8.37,106.59l11.63.2c4.33-6.25,18.84-92.15,11.89-142.6a124,124,0,0,1-40.88,5.31q4.92.15,9.81,0A248.24,248.24,0,0,1,113.21,349.88Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M70.88,315c11.62,25.95,13.91,110.86,7.58,141.64l12.77.12c4.77-5.81,25-86.46,22.8-137.39A167.16,167.16,0,0,1,70.88,315Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M232.16,200l2.19-.9c.62-.26,1.17-.5,1.64-.72h0s3.24-7.94,12-9.69a54.08,54.08,0,0,1,26.11.83c3.86,1.05,5.3,2.63,4.4,4-1.14,1.68-17.46-1.38-18.62.88a3.39,3.39,0,0,0,.22,3.87,6.24,6.24,0,0,1-.95,7.87c-3.62,3.48-16.35,2.87-18.55,1.85l-1.52.93-1.72,1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M77.17,267.56c-3.83,22.1-6.94,41.66-7.92,47,25.9,6,51.68,7.15,76.43-.72-.71-12.44-1.28-24.8-1.82-37.18m-2.06-47.16c-.11-2.16-.21-4.32-.32-6.48,17.39,8.94,36.75,15.91,55.78,9.52l40.53-22-6-11L185.31,216c-28.77-6-35.73-18.51-53.41-24.25A78.21,78.21,0,0,0,120.6,189m-13.26-.87A59.9,59.9,0,0,0,95,189.77"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M238.54,212l-1.93,1h0a1.56,1.56,0,0,1-2.06-.52l-7.1-10.94a1.62,1.62,0,0,1-.19-.37,1.57,1.57,0,0,1,1-2l3.08-1.08h0a1.56,1.56,0,0,1,1.88.73l5.92,10.89.07.11a1.57,1.57,0,0,1-.63,2.13Zm-2.68-.33,1.93-1.05-6-11-3.08,1.09Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M100.29,188.73c3.9,21.49,35.43,18.32,27.19,1.68-2.17-.57-4.37-1-6.58-1.41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "123.29 196.2 122.97 200.81 119.85 201.12 117.83 197.65 121.05 193.54 121.09 193.57 123.29 196.2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M104.08,267.12q-1,3.87-2.1,7.55c-1.74,6.4.88,8.48,4.8,8.86,10.33,1,20,1.68,30.18,2,6.11.22,5.45-5.19,8.54-15.2,1.73-7.05,2.57-10.92,5.09-20.53,2.59-11.67,6.33-16.92-.89-19.15-7.91-1.36-16.17-1.79-27.45-3-5.66-.61-7.77.49-10.24,10.06-1.52,5.34-3,11-4.56,16.78"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M121.06,193.54l-5.67,7.23-4.77-7.85L101,188.63c1.35-.18,2.92-.37,4.36-.45.14.47,12.16,6.72,15.67,5.33Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M128.26,254a7.39,7.39,0,0,0-2.59-1.55s-.84-2.94,1.79-4.08,3.39,1,5.57.3c4.26-1.37,4.69,7.53.85,12.1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M121.06,193.54l3.7,4.42L123,191.43l-.92-1-.28-1.3-.92-.16c1.5,2.67,1.3,4,.16,4.49Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M135.8,145.45c-3,13.79,1.35,12,.75,19.93-.68,9.06-9.25,14.4-18.45,14.52.22,4.12.77,8.76,2.79,9.1,6,10.76-15.38-.19-15.56-.82.54,0,1.94-.07,1.94-.11l1.34-10a21.73,21.73,0,0,1-6-3.79,8.77,8.77,0,0,0,2.15-.5c1-4.5-1-11.51-2.38-13.82-.4-.69-1.47-.6-2.41-1.23-2.55-1.74-2.26-9.72,1.6-10.59a4.11,4.11,0,0,1,4.16,2.13c.1.15,1.1-6.36,6.33-6.77,0,0,3,6.76,21.24,2.69A19.58,19.58,0,0,0,135.8,145.45Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M93.4,127c-6.47.9-9.26,8.24-9.3,15-.06,9.85,5.26,21.35,10.49,28.33a8.85,8.85,0,0,0,8,3.93h.14l.12,0h0l.18,0h.05l.12,0,.07,0,.1,0,.1,0,.1,0,.1,0,.05,0,.15,0,.06,0,.14,0h0l.34-.11,0,0,.19-.06c1-4.5-1-11.51-2.38-13.82-.4-.69-1.47-.6-2.41-1.23-2.55-1.74-2.26-10.16,1.6-11h1l.14,0h.14l.13,0,.35.1.11,0,0,0a3.65,3.65,0,0,1,.53.25l.1.06a5,5,0,0,1,.67.49l.06.06.1.09.13.12.13.14.17.2.12.15.12.15,0,.08.06.08,0,.09c.1.14,1.1-7.7,6.33-8.11,0,0,3,7.21,21.24,3.13,17.72-4,6.05-24.53.36-27.81C119.1,108.7,100,112.37,96.09,124c.22-1.3.85-2.43.44-2.83s-2.2,1.17-1.88,4l-.16-.07c-4.58-2-8.23,0-7.6,1.12s3.82-.13,6.51.85Zm40.19,19.36c-15,3.35-20.51-.82-22.27-2.93-2.73.92-3.73,5.19-4,6.37h0a1.79,1.79,0,0,1-.74,1.3h0a1.34,1.34,0,0,1-2.19-.43h0l-.06-.09h0l0-.07h0l0-.05h0l-.09-.12h0l-.06-.08h0l-.06-.07h0l-.09-.1h0l-.1-.1,0,0h0l-.1-.09h0l0,0h0a2.13,2.13,0,0,0-.22-.18,1.53,1.53,0,0,0-.23-.15h0l-.06,0h0l-.16-.08h0a.64.64,0,0,0-.16-.07h0l-.09,0-.08,0-.09,0h0l-.11,0h-.58a1.88,1.88,0,0,0-1,.82,6.29,6.29,0,0,0-.9,2.67,9.22,9.22,0,0,0,.11,3.12,2.89,2.89,0,0,0,.77,1.61,3.52,3.52,0,0,0,.84.34,3,3,0,0,1,2,1.4,27.24,27.24,0,0,1,2.45,7.72,20.12,20.12,0,0,1,.11,7.2l-.19.86-.82.29-.19.07H105l-.17,0h0l-.17,0h-.08l-.13,0h0l-.06,0h0l-.16,0h-.07l-.11,0h0l-.09,0h0l-.11,0h0l-.1,0h-.1l-.12,0h-.08l-.19,0H103l-.12,0h-.18a9.35,9.35,0,0,1-5.16-.94,11.84,11.84,0,0,1-4.24-3.61,60.08,60.08,0,0,1-7.92-14.72A42.31,42.31,0,0,1,82.54,142a22,22,0,0,1,2.88-11.21,13,13,0,0,1,2.13-2.63,2.4,2.4,0,0,1-2-1.23h0a2.06,2.06,0,0,1-.24-1.45h0a2.9,2.9,0,0,1,1.34-1.81,5.93,5.93,0,0,1,2.09-.85,9.77,9.77,0,0,1,4.47.12,5.78,5.78,0,0,1,.56-1.6,4.16,4.16,0,0,1,1-1.25,2.29,2.29,0,0,1,1.75-.62l.17,0c2.75-3.85,7.27-6.5,12.58-7.75a34.68,34.68,0,0,1,18.85,1.08,35.08,35.08,0,0,1,6.3,2.85c2.31,1.33,5.45,5.09,7.52,9.49a22.61,22.61,0,0,1,2.33,9,11.22,11.22,0,0,1-3.18,8.5A14.9,14.9,0,0,1,133.59,146.4Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M123.82,202.73l-.87-2.06-3.17.34-.27,2.79A13.71,13.71,0,0,0,123.82,202.73Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M129.66,191a22.6,22.6,0,0,0-2.18-.6c8.24,16.64-23.29,19.81-27.19-1.68-.77.11-1.54.25-2.31.39,1.78,6.69,4.29,11.36,8.12,14.17C114.5,209.47,134.94,207.3,129.66,191Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M130.5,161a.73.73,0,1,1-1.39-.42.87.87,0,0,0,0-.34.36.36,0,0,0-.07-.19L129,160a1.3,1.3,0,0,0-.73-.25h0a1.28,1.28,0,0,0-.73.16l-.08.07a.68.68,0,0,0-.13.24v0a1.65,1.65,0,0,0-.08.43.73.73,0,1,1-1.45-.15,2.93,2.93,0,0,1,.15-.75v0a2.12,2.12,0,0,1,.41-.72,2.35,2.35,0,0,1,.33-.3,2.62,2.62,0,0,1,1.67-.42h0a2.73,2.73,0,0,1,1.59.61,1.47,1.47,0,0,1,.29.32,1.74,1.74,0,0,1,.33.87A2.15,2.15,0,0,1,130.5,161Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M150.92,236.75c.05-1.8-.44-3.74-2.39-3.93l-26.77-3.17s-3.07-.74-4.5,1.67c-.72,1.2-3.92,12.57-7,23.68M107,267.15c-1.56,5.8-2.66,10-2.66,10s-.76,3.37,3.32,3.87"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M113.51,257.44l1.37.08s.14.14,2.33-2.4,7.49-4.88,8-2.87-4,1.84-3.79,2.72,6.37-.47,7.88-1.56,3.89-.23,4.48,4.29-1.53,7.73-7.24,7.95c-4.32.17-8.86-1.45-10.92-1.47H114"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M99.73,209.24a39.44,39.44,0,0,1-3,6.89c-2,3.83-13.73,19.33-16.88,33.21l32.25,6.22c2.15,1.92,2.33,8.25,1,10.9,0,0-42.81,3.91-48.3-2s-6.31-8.34-4.94-14.71c3.2-16.47,16.64-51.27,30.94-58.49a22.61,22.61,0,0,1,5.1-1.68"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M109.3,255l2.85.55c2.16,1.93,2.32,8.28,1,10.9,0,0-1.12.1-3,.24a36.32,36.32,0,0,0,.61-6.34A15.67,15.67,0,0,0,109.3,255Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M122,233.9c.6.19.81,1.23.46,2.33s-1.11,1.84-1.71,1.65-.81-1.23-.47-2.33S121.35,233.71,122,233.9Z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 151.05,
    x2: 141.13,
    y1: 237.98,
    y2: 277.81,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M110,281.35l25,2c3.4.28,4.7-.76,5.72-4.57"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 223.48,
    x2: 223.48,
    y1: 218.47,
    y2: 234.57,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M223.48,223.6A91.76,91.76,0,0,1,244.15,209m17.1-6c33.68-6.89,59.19,16.51,59.2,20.65"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M214.83,40.64a1.47,1.47,0,0,1-2.1-2,1.54,1.54,0,0,1,.28-.29c.82-.65,1.64-1.27,2.49-1.88a1.46,1.46,0,0,1,1.8,2.3c-.82.63-1.66,1.23-2.47,1.87Zm14.84-8.58a1.46,1.46,0,1,1-1-2.74,54.42,54.42,0,0,1,5.73-1.81,1.47,1.47,0,0,1,.85,2.8l-.14,0a50.88,50.88,0,0,0-5.42,1.71ZM249.16,29a1.46,1.46,0,0,1-.28-2.87,1.35,1.35,0,0,1,.45-.05,54.47,54.47,0,0,1,6,.65,1.46,1.46,0,0,1,0,2.89,1.77,1.77,0,0,1-.46,0,51.36,51.36,0,0,0-5.65-.62Zm19.25,4.75a1.46,1.46,0,0,1,1.2-2.66c1.83.81,3.6,1.7,5.35,2.68a1.46,1.46,0,0,1-1.44,2.55q-2.49-1.4-5.11-2.57Zm16.8,10.82a1.46,1.46,0,0,1,1.63-2.4,1.15,1.15,0,0,1,.29.2c1.5,1.3,2.95,2.67,4.35,4.08a1.47,1.47,0,0,1-1.71,2.33,1.55,1.55,0,0,1-.39-.28q-2-2-4.17-3.93ZM298.4,59.6a1.47,1.47,0,0,1,2.26-1.84l.19.23q1.31,2,2.47,4h-3.39Q299.2,60.8,298.4,59.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomework);
export default __webpack_public_path__ + "static/media/homework.4c393b3f5173e45cfe4ef521837f9d64.svg";
export { ForwardRef as ReactComponent };